<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('userProfile.frdiMlumatlar')" />
      <div class="row">
        <div
          v-if="user"
          class="col-lg-8"
        >
          <div class="profile-card">
            <div class="profile-header">
              <h3 class="mb-0">{{ $t('userProfile.frdiMlumatlar') }}</h3>
            </div>
            <div class="profile-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="profile-photo-container">
                    <input
                      id="fileInput"
                      ref="file"
                      type="file"
                      style="display: none"
                      @change="setPhoto"
                    >
                    <div class="profile-photo-wrapper">
                      <img
                        :src="getPhoto(user.photo,'mediumCropped')"
                        alt=""
                        class="profile-photo"
                      >
                      <div class="profile-photo-overlay">
                        <button
                          class="btn btn-sm btn-light edit-photo-btn"
                          @click="selectPhoto"
                          title="Edit Photo"
                        >
                          <i class="fa fa-pencil" />
                        </button>
                      </div>
                    </div>
                    <div class="mt-2 text-center">
                      <button
                        v-if="user.photo"
                        class="btn btn-sm btn-light-danger"
                        @click.prevent="removeProfilePhoto"
                      >
                        <i class="fa fa-trash" /> {{ $t('userProfile.sklSlmkIstdyn') }}
                      </button>

                      <div
                        v-if="uploadProgress > 0 && uploadProgress < 100"
                        class="progress mt-2"
                      >
                        <div
                          class="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          aria-valuenow="75"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          :style="{width: `${uploadProgress}%`}"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="user-info-card">
                    <div class="user-name">
                      <h4 class="mb-0">{{ user.name }} {{ user.surname }}</h4>
                      <div class="user-id">
                        {{ user.uniqueId }}
                      </div>
                    </div>

                    <div class="info-section">
                      <div class="info-label">
                        <i class="fa fa-phone text-primary mr-2"></i>
                        {{ $t('userProfile.telefon') }}
                      </div>
                      <div class="info-value">
                        {{ user.phone }}
                      </div>
                    </div>

                    <div class="info-section">
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <div class="info-content">
                          <div class="info-label">
                            <i class="fa fa-envelope text-primary mr-2"></i>
                            E-mail
                          </div>
                          <div class="info-value">
                            {{ user.email }}
                          </div>
                        </div>
                        <div>
                          <button
                            class="btn btn-primary edit-btn"
                            @click="changeEmail"
                          >
                            <i class="fa fa-pencil mr-1" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="info-section">
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <div class="info-content">
                          <div class="info-label">
                            <i class="fa fa-lock text-primary mr-2"></i>
                            {{ $t('login.ifr') }}
                          </div>
                          <div class="info-value">
                            •••••••••
                          </div>
                        </div>
                        <div>
                          <button
                            class="btn btn-primary edit-btn"
                            @click="changePassword"
                          >
                            <i class="fa fa-pencil mr-1" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="danger-card">
            <div class="danger-card-header">
              <h4 class="mb-0">{{ $t('userProfile.hesabmSil') }}</h4>
            </div>
            <div class="danger-card-body">
              <div class="warning-icon">
                <i class="fa fa-exclamation-triangle"></i>
              </div>
              <p>
                {{ $t('userProfile.hesabnzSildikdnSonraSizinXsiBilgilrinizSistemdnSil') }}
              </p>
              <button
                class="btn btn-danger btn-block"
                @click.prevent="deleteAccount"
              >
                <i class="fa fa-trash mr-1"></i> {{ $t('userProfile.hesabmSil') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->


    <b-modal
      id="modal-edit-password"
      centered
      :title="$t('login.ifrmiYenil')"
      :hide-footer="true"
      class="theme-modal password-modal"
    >
      <div>
        <form @submit.prevent="setPassword">
          <div class="mb-4">
            <label
              for="oldPassword"
              class="form-label font-weight-bold"
            >{{ $t('passwordChange.yeniIfr') }}</label>
            <div class="input-group password-input-group">
              <input
                id="oldPassword"
                v-model="password"
                :type="`${passwordVisible?'text': 'password'}`"
                class="form-control"
                placeholder="Enter new password"
              >
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-light password-toggle-btn"
                  @click.prevent="passwordVisible=!passwordVisible"
                >
                  <i :class="`${passwordVisible?'fa fa-eye-slash': 'fa fa-eye'}`" />
                </button>
              </div>
            </div>
          </div>

          <div class="password-strength-meter mb-4">
            <div class="strength-label d-flex justify-content-between mb-1">
              <span>{{ $t('passwordChange.ifrTyinat') }}</span>
              <span class="strength-text" :class="`text-${scorePassword.color}`">{{ scorePassword.name }}</span>
            </div>
            <div class="progress">
              <div
                class="progress-bar"
                :class="`bg-${scorePassword.color}`"
                :style="{width: `${scorePassword.percent}%`}"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
          </div>

          <div class="password-requirements mb-4">
            <div class="requirement-title mb-2">{{ $t('specialRequirements') }}:</div>
            <ul class="requirements-list">
              <li :class="{ 'satisfied': password && password.length >= 8 }">
                {{ $t('passwordChange.requirementLength') }}
              </li>
              <li :class="{ 'satisfied': /[A-Z]/.test(password) }">
                {{ $t('passwordChange.requirementUpperCase') }}
              </li>
              <li :class="{ 'satisfied': /[a-z]/.test(password) }">
                {{ $t('passwordChange.requirementLowerCase') }}
              </li>
              <li :class="{ 'satisfied': /\d/.test(password) }">
                {{ $t('passwordChange.requirementDigit') }}
              </li>
              <li :class="{ 'satisfied': /\W/.test(password) }">
                {{ $t('passwordChange.requirementSpecialChar') }}
              </li>
            </ul>
          </div>

          <div class="text-right">
            <button
              class="btn btn-secondary mr-2"
              type="button"
              @click="$bvModal.hide('modal-edit-password')"
            >
              {{ $t('companyProfile.lvEt2') }}
            </button>
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="scorePassword.percent <= 50"
            >
              {{ $t('login.ifrmiYenil') }}
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  changeEmail,
  deleteAccount,
  removeProfilePhoto, updateProfilePhoto, upload,
  userAccounts, userMe, userSetPassword,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import {store} from "@/store";

export default {
  data() {
    return {
      mediaBase: mediaBase,
      accounts: [],
      uploadProgress: 0,
      password: '',
      passwordVisible: false,
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),

    scorePassword() {
      let score = 0;
      if (!this.password)
        return score;

      // award every unique letter until 5 repetitions
      let letters = new Object();
      for (let i = 0; i < this.password.length; i++) {
        letters[this.password[i]] = (letters[this.password[i]] || 0) + 1;
        score += 5.0 / letters[this.password[i]];
      }

      // bonus points for mixing it up
      let variations = {
        digits: /\d/.test(this.password),
        lower: /[a-z]/.test(this.password),
        upper: /[A-Z]/.test(this.password),
        nonWords: /\W/.test(this.password),
      }

      let variationCount = 0;
      for (let check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0;
      }
      score += (variationCount - 1) * 10;

      score = parseInt((score / 20) + "");
      //TODO LANGUAGE
      switch (score) {
        case 0:
          return {name: this.$t("passwordChange.risk"), percent: 10, score: score, color: 'danger'};
        case 1:
          return {name: this.$t("passwordChange.texmin"), percent: 30, score: score, color: 'danger'}
        case 2:
          return {name: this.$t("passwordChange.zeif"), percent: 50, score: score, color: 'warning'}
        case 3:
          return {name: this.$t("passwordChange.guclu"), percent: 70, score: score, color: 'primary'}
        case 4:
          return {name: this.$t("passwordChange.secure"), percent: 100, score: score, color: 'success'}
        default:
          return {name: this.$t("passwordChange.namelum"), percent: 0, score: score, color: 'dark'}
      }
    },
  },
  mounted() {
    this.getUserProfile();

    userAccounts(this.token).then(data => {
      this.accounts = data;
    })
  },
  methods: {

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getUserProfile() {
      userMe(this.token).then(({code, message, type, user, company, profileType, position}) => {

        if (code === 200) {

          store.dispatch('auth/setUser', user);
          store.dispatch('auth/setCompany', company);
          store.dispatch('auth/setProfile', profileType);
          store.dispatch('auth/setPosition', position);
          store.dispatch('auth/setSessionType', type);

        } else if (code === 401) {
          localStorage.removeItem("token");
          return this.$router.push("/auth/login");
        } else {
          this.$swal({
            title: `Error ${code}`,
            text: `${message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }

      })
    },
    removeProfilePhoto() {
      if (confirm(this.$t("userProfile.sklSlmkIstdyn"))) {
        removeProfilePhoto(this.token).then(data => {
          if (data.code === 200) {
            this.getUserProfile();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },

    deleteAccount() {

      this.$swal({
        title: this.$t("userProfile.hsbnzSlmzSbbQyd"),
        input: 'text',
        icon: 'question',
        inputPlaceholder: this.$t("request.sbb"),
        showCancelButton: true,
        confirmButtonText: this.$t("userProfile.hesabmSil"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          deleteAccount(this.token, result.value).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("userProfile.hsbnzSldi"),
                icon: 'success'
              }).then(() => {
                this.$router.replace('/');
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }
      });
    },

    changeEmail() {
      this.$swal({
        title: this.$t("userProfile.ynMlnzDxlEdin"),
        text: this.$t("userProfile.brMlYlnzHsb"),
        input: 'email',
        icon: 'question',
        inputPlaceholder: 'e-mail',
        showCancelButton: true,
        confirmButtonText: this.$t("userProfile.mlDys"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {


        if (result.value) {

          if (result.value === this.user.email) {
            return this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("userProfile.ynMlnzkhnMlndnFrql"),
              icon: 'warning'
            })
          }

          changeEmail(this.token, result.value).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("userProfile.mlnzYnlnd"),
                icon: 'success'
              }).then(() => {
                this.getUserProfile();
              })
            } else if (data.code === 409) {
              this.$swal({
                title: this.$t("generalModal.warningTitle"),
                text: this.$t("userProfile.buMlArtqIstfdOlnr"),
                icon: 'warning'
              }).then(() => {
                this.getUserProfile();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }
      });
    },

    changePassword() {
      this.$bvModal.show('modal-edit-password');
    },

    setPassword() {

      if (this.scorePassword.percent <= 50) {
        return this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("passwordChange.message"),
          icon: 'warning'
        })
      }

      userSetPassword(this.token, this.password).then(({code, message}) => {

        if (code === 200) {
          this.$swal({
            title: this.$t("congratulations"),
            text: this.$t("userProfile.sfrnzUgrlDysdrl"),
            icon: 'success',
          }).then(() => {
            this.getUserProfile();
            this.$bvModal.hide('modal-edit-password');
          })
        } else if (code === 401 || code === 404) {
          this.$swal({
            title: this.$t("err"),
            text: this.$t("passwordChange.errorMessage"),
            icon: 'error',
          })
        } else {
          this.$swal({
            title: `Error ${code} !`,
            text: message,
            icon: 'error',
          })
        }

      });

    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'profilePhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                updateProfilePhoto(this.token, response.data.path).then(data => {
                  if (data.code === 200) {
                    this.getUserProfile();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }
                })

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    }
  }

}
</script>
<style>
/* General styles */
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}

/* Profile card styles */
.profile-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 2rem;
}

.profile-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.profile-header {
  background-color: #f8f9fa;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #eaeaea;
}

.profile-body {
  padding: 1.5rem;
}

/* Profile photo styles */
.profile-photo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-photo-wrapper {
  position: relative;
  width: 100%;
  max-width: 180px;
  margin-bottom: 1rem;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.profile-photo {
  width: 100%;
  height: auto;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.profile-photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.profile-photo-wrapper:hover .profile-photo-overlay {
  opacity: 1;
}

.edit-photo-btn {
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.edit-photo-btn:hover {
  background-color: #fff;
  transform: scale(1.1);
}

/* User info card styles */
.user-info-card {
  padding: 0.5rem 0;
}

.user-name {
  margin-bottom: 1.5rem;
}

.user-id {
  color: #6c757d;
  font-size: 0.9rem;
}

.info-section {
  padding: 1rem 0;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  flex-direction: column;
}

.info-section:last-child {
  border-bottom: none;
}

.info-label {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.info-value {
  font-size: 1.1rem;
  font-weight: 500;
}

.info-content {
  flex: 1;
}

.edit-btn {
  padding: 0.375rem 1rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.edit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Danger card styles */
.danger-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  border-top: 4px solid #dc3545;
}

.danger-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.danger-card-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #eaeaea;
  color: #dc3545;
}

.danger-card-body {
  padding: 1.5rem;
  text-align: center;
}

.warning-icon {
  font-size: 3rem;
  color: #dc3545;
  margin-bottom: 1rem;
}

/* Password modal styles */
.password-modal .modal-content {
  border-radius: 8px;
  overflow: hidden;
}

.password-input-group {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
}

.password-toggle-btn {
  border: none;
  background-color: #f8f9fa;
}

.password-strength-meter {
  margin-top: 1rem;
}

.strength-text {
  font-weight: 600;
}

.password-requirements {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
}

.requirement-title {
  font-weight: 600;
}

.requirements-list {
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0;
}

.requirements-list li {
  position: relative;
  padding-left: 1.5rem;
  margin-bottom: 0.5rem;
  color: #6c757d;
}

.requirements-list li:before {
  content: "✕";
  position: absolute;
  left: 0;
  color: #dc3545;
}

.requirements-list li.satisfied {
  color: #28a745;
}

.requirements-list li.satisfied:before {
  content: "✓";
  color: #28a745;
}

/* Responsive adjustments */
@media (max-width: 767.98px) {
  .profile-photo-wrapper {
    max-width: 150px;
  }

  .info-section {
    flex-direction: column;
  }

  .edit-btn {
    margin-top: 0.5rem;
  }
}
</style>
